import './CheckBox.css'
import { ReactComponent as IcCheck } from '../../assets/icon/ic_check.svg'
import { Dispatch, SetStateAction } from 'react';

export interface CheckBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  title: string;
  id: string;
  checked: boolean;
  setChecked: Dispatch<SetStateAction<boolean>>
  required?: boolean;
  requiredLabel?: string;
}

export const CheckBox = ({title, id, checked, setChecked, required, requiredLabel, ...rest}: CheckBoxProps) => {
    return (
        <div style={{margin: "8px 0", display: "inline-block", width: "fit-content"}}>
            <input
                className="common-checkbox"
                type="checkbox"
                checked={checked}
                {...rest}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setChecked(e.target.checked)
                    rest.onChange && rest.onChange(e)
                }}
                id={id}
                hidden
            />
            <label
                className="common-checkbox-label"
                htmlFor={id}
                style={{width: 'auto'}}
            >
                <div className="common-checkbox-label-box">
                    {checked &&
                        <IcCheck className="common-checkbox-checked-icon"/>
                    }
                </div>
                <span className="common-checkbox-label-title">{title}</span>
                {required &&
                    <span className="common-checkbox-label-required">{requiredLabel}</span>
                }
            </label>
        </div>
    )
}
